export const setCssVar = (varName: string, value: string | number) => {
  return {
    [varName]: value,
  } as React.CSSProperties
}
